import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Area, Box, Modal } from '@ublend-npm/aulaui-core';
import { getCurrentSpaceId } from '@core/selectors/space';

import useBreakpoints from '@app/hooks/useBreakpoints';
import pushRoute from '@app/utils/routing';
import { AulaDispatch, AulaState } from '@core/types/state';
import changeConversationOpen from '@core/conversations/operationsResponsive/changeConversationOpen.action';
import CreateConversation from './CreateConversation';

interface CreateConversationModalProps {
  queryParams?: Record<string, string>;
}

const CreateConversationModal = ({
  queryParams = {},
}: CreateConversationModalProps) => {
  const { lg } = useBreakpoints();

  const dispatch: AulaDispatch = useDispatch();
  const spaceId = useSelector(getCurrentSpaceId);
  const open = useSelector(
    (state: AulaState) => state.inboxv2.createConversationOpen
  );
  const handleCreateConversationClose = () => {
    dispatch(changeConversationOpen(false));
  };

  // This modal should be a separate page if the screen is too small
  // Redirect if open and screen is small
  useEffect(() => {
    if (open && !lg) {
      const queryString =
        Object.keys(queryParams).length > 0
          ? `?${new URLSearchParams(queryParams).toString()}`
          : '';
      pushRoute(`dashboard/${spaceId}/messages/new${queryString}`);
      handleCreateConversationClose();
    }
  }, [open, lg]);

  return (
    <Modal open={open} onClose={handleCreateConversationClose}>
      <Box sx={{ width: 'min(1152px, 100dvw)' }}>
        <Area rounded>
          <CreateConversation onClose={handleCreateConversationClose} />
        </Area>
      </Box>
    </Modal>
  );
};

export default CreateConversationModal;
